<template>
  <div class="nav-side-menu mouseoverscroll">
    <div class="brand">ISACI</div>
    <i class="fa fa-bars fa-2x toggle-btn" @click="toggleMenu"></i>

    <div class="menu-list">
      <div id="menu-panel" class="menu-content" :class="{ 'collapsed': !menuExpanded, 'show': menuExpanded }">
        <div id="panel-greeting">
          Welcome, {{ userName }}
        </div>
        <div class="panel-buttons">
          <div class="panel-btn">
            <router-link to="/profile">
              <i class="iconfont icon-renwu"></i> My Profile
            </router-link>
          </div>
          <div class="panel-btn">
            <button @click="logout">
              <i class="iconfont icon-exit-full"></i> Logout
            </button>
          </div>
        </div>
      </div>
      <ul id="menu-content" class="menu-content" :class="{ 'collapsed': !menuExpanded, 'show': menuExpanded }">
        <li>
          <router-link to="/official">
            <i class="iconfont icon-home"></i> ISACI Home
          </router-link>
        </li>
        <li @click="toggleSubMenu" class="menu-toggle">
          <a href="#" @click.prevent>
            <i class="iconfont icon-qianbi"></i> Participant Services 
            <i class="iconfont icon-xiangxia" :class="{ 'rotated': subMenuExpanded }" style="float: right; margin-right: 10px;"></i>
          </a>
        </li>
        <li class="sub-menu-list">
          <ul class="sub-menu" :class="{ 'expanded': subMenuExpanded, 'show': subMenuExpanded }" id="nav-author">
            <!-- <li><router-link to="/my-abstracts"> Abstract Overview</router-link></li> -->
            <!-- <li><router-link to="/invoices">Payment Summary</router-link></li> -->
            <li><router-link to="/registration">Workshop Registration</router-link></li>
            <!-- <li><router-link to="/member-registration">Member Registration</router-link></li> -->
            <li><router-link to="/registration-slip">Participation Pass</router-link></li>
            <li><router-link to="/proof-attendance">Attendance Certificate</router-link></li>
            <!-- <li><router-link to="/schedule">Conference Schedule</router-link></li> -->
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { apiService } from '@/config/api'
export default {
  name: 'Sidebar',
  data() {
    return {
      userName: 'Guest',
      menuExpanded: true, // 默认展开
      subMenuExpanded: true, // 默认展开子菜单
      convenerMenuExpanded: true, // Convener Options子菜单
      userLevel: Number(localStorage.getItem('userLevel')) || 1 // 动态获取
    }
  },
  mounted() {
    this.userLevel = Number(localStorage.getItem('userLevel')) || 1
    // 手机端默认折叠
    if (window.innerWidth <= 768) {
      this.menuExpanded = false
      this.subMenuExpanded = false
      this.convenerMenuExpanded = false
    }
  },
  created() {
    this.getProfile()
  },
  methods: {
    // 获取用户信息
    // async getUserInfo() {
    //   const response = await apiService.auth.getProfile()
    //   this.userName = response.data.data.first_name + ' ' + response.data.data.last_name
    // },
    async getProfile() {
      try {
        const response = await apiService.auth.getProfile()
        if (response.data && response.data.data) {
          const userData = response.data.data
          this.userName = (userData.title || '') + ' ' + (userData.first_name || '') + ' ' + (userData.last_name || '')
        } else {
          console.warn('用户数据格式不正确:', response.data)
          this.userName = '用户'
        }
      } catch (error) {
        console.error('获取用户信息失败:', error)
        this.userName = '用户'
        // 如果是401错误，重定向到登录页面
        if (error.response && error.response.status === 401) {
          this.$router.push('/login')
        }
      }
    },
    logout() {
      // 实现登出逻辑

      localStorage.removeItem('authToken')
      localStorage.removeItem('userLevel')
      this.$router.push('/login')
      
    },
    toggleMenu() {
      this.menuExpanded = !this.menuExpanded
    },
    toggleSubMenu() {
      this.subMenuExpanded = !this.subMenuExpanded
    },
    toggleConvenerMenu() {
      this.convenerMenuExpanded = !this.convenerMenuExpanded
    }
  }
}
</script>

<style scoped>
/* 侧边栏特定样式已在common.css中定义 */

.nav-side-menu {
  max-height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

/* 按钮容器横向布局 */
.panel-buttons {
  display: flex;
  gap: 10px;
  padding: 0 10px 10px 10px;
}

.panel-buttons .panel-btn {
  flex: 1;
}

.panel-buttons .panel-btn a,
.panel-buttons .panel-btn button {
  width: 100%;
  padding: 8px;
  font-size: 12px;
  text-align: center;
}

/* 菜单切换样式 */
.menu-toggle {
  cursor: pointer;
}

.menu-toggle a {
  cursor: pointer;
}

.icon-xiangxia {
  transition: transform 0.3s ease;
}

.icon-xiangxia.rotated {
  transform: rotate(180deg);
}

/* 折叠/展开动画 */
.menu-content {
  transition: all 0.3s ease;
}

.menu-content.collapsed {
  display: none;
}

.sub-menu {
  transition: all 0.3s ease;
  overflow: hidden;
}

.sub-menu:not(.expanded) {
  max-height: 0;
  opacity: 0;
}

.sub-menu.expanded {
  max-height: 300px;
  opacity: 1;
}

/* PC端默认展开状态 */
@media (min-width: 769px) {
  .menu-content:not(.collapsed) {
    display: block !important;
  }
  
  .sub-menu.expanded {
    display: block !important;
  }
  
  .toggle-btn {
    display: none; /* PC端隐藏toggle按钮 */
  }
}

/* 手机端样式 */
@media (max-width: 768px) {
  .toggle-btn {
    display: block; /* 手机端显示toggle按钮 */
  }
  
  .menu-content.show {
    display: block !important;
  }
  
  .sub-menu.show {
    display: block !important;
    max-height: none;
    opacity: 1;
  }
}
</style> 